var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar__cart", class: _vm.sidecartOpen ? "open" : "" },
    [
      _c(
        "cart-modal",
        [
          _c(
            "v-button",
            {
              attrs: { label: "Open Cart", "aria-label": "Open Cart" },
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("cart/openSidecart")
                }
              }
            },
            [
              _c("span", { staticClass: "u-sr-only" }, [_vm._v("Open Cart")]),
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "32",
                    height: "32"
                  }
                },
                [
                  _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
                    _c("rect", {
                      staticClass: "innersvg",
                      attrs: {
                        fill: "#FFFFFF",
                        x: "6",
                        y: "8",
                        width: "20",
                        height: "20"
                      }
                    }),
                    _c("path", { attrs: { d: "M6 8h20v20H6z" } }),
                    _c("path", {
                      attrs: {
                        fill: "#000000",
                        "fill-rule": "nonzero",
                        d:
                          "M16 3.5a4.5 4.5 0 00-4.5 4.29V8h-1a5.5 5.5 0 0111-.22V8H26v20H6V8h14.5A4.5 4.5 0 0016 3.5zM25 9H7v18h18V9z"
                      }
                    })
                  ])
                ]
              ),
              _vm.numCartItems >= 0
                ? _c(
                    "span",
                    {
                      staticClass: "cart-bubble-quantity navbar__cart__quantity"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cart-bubble-count navbar__cart__count",
                          class: [
                            _vm.cartBubbleColors.bubbleText,
                            {
                              "cart-bubble-count--small":
                                _vm.numCartItems >= 100
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.numCartItems < 100 ? _vm.numCartItems : "99+"
                            )
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }